import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Row, Col } from 'react-bootstrap';
import { Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import ChildrenDropdownList from '../children/DropdownList';

const NewMakeupForm = ({ error, handleSubmit, pristine, data, submitting, submitSucceeded, isReadonly, t }) => {
	return (
		<Form onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Row>
				<Col sm={6}>
					<Field name='grade.name' component={Static} label={t('LessonAttendance_Grade')} />
				</Col>
				<Col sm={6}>
					<Field name='lessonDate' component={Static} formatType='date' label={t('LessonAttendance_LessonDate')} />
				</Col>
			</Row>
			<ChildrenDropdownList render='field' name='childId' disabled={isReadonly} required
				label={t('LessonAttendance_Child')} validate={[validators.required]} />
		</Form>
	);
};

export default reduxForm({ form: 'newMakeupForm' })(NewMakeupForm);
